import type { CmdbAsyncActionStoreAction } from '../../types';

export const showTaskFlags = (): CmdbAsyncActionStoreAction => async () => undefined;
